import React, {type JSX} from 'react';
import {Box, FormLabel, Typography} from '@mui/material';
import {useFormikContext} from 'formik';
import {type FormValues} from '../constants/types';
import {BlockHeader, InputRadioButton} from './shared';

const radioButtonContainerSx = {
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  alignItems: 'center',
  paddingTop: 1,
};

function RequestRecordsRadioBtnBlock(): JSX.Element {
  const {values, setFieldValue} = useFormikContext<FormValues>();

  return (
    <Box mb={5} data-testid="patient-request-records">
      <BlockHeader title="Please select whether you have records for this patient" />
      <Box sx={radioButtonContainerSx}>
        <InputRadioButton
          name="isRequestHaveMedicalRecords"
          id="have-medical-records"
          value="have"
          slotProps={{
            input: {
              'data-testid': 'have-medical-records-radio-btn',
            },
          }}
          checked={values.isRequestHaveMedicalRecords === 'have'}
          onChange={() => {
            setFieldValue('isRequestHaveMedicalRecords', 'have');
          }}
        />
        <FormLabel htmlFor="have-medical-records">
          <Typography component="p" variant="body3" color="textPrimary">
            I have medical records for this patient
          </Typography>
        </FormLabel>
        <div />
        <Typography
          gutterBottom
          component="p"
          variant="body5"
          color="textSecondary"
        >
          The medical records you upload will be securely shared with the
          patient
        </Typography>
      </Box>
      <Box sx={radioButtonContainerSx}>
        <InputRadioButton
          name="isRequestHaveMedicalRecords"
          id="do-not-have-medical-records"
          value="do-not-have"
          slotProps={{
            input: {
              'data-testid': 'do-not-have-medical-records-radio-btn',
            },
          }}
          checked={values.isRequestHaveMedicalRecords === 'do-not-have'}
          onChange={() => {
            setFieldValue('isRequestHaveMedicalRecords', 'do-not-have');
          }}
        />
        <FormLabel htmlFor="do-not-have-medical-records">
          <Typography component="p" variant="body3" color="textPrimary">
            I do not have medical records for this patient
          </Typography>
        </FormLabel>
        <div />
        <Typography
          gutterBottom
          component="p"
          variant="body5"
          color="textSecondary"
        >
          The patient will be notified that there are no medical records
          available at this time
        </Typography>
      </Box>
    </Box>
  );
}

export default RequestRecordsRadioBtnBlock;
